export default {
  audits: [],
  totalResults: 0,
  isLoading: true,
  filterOptions: [],
};
